var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Update Shipment Status")]), _vm._v(" "), _c('b-card', [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipping ID")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShipmentId),
      expression: "ShipmentId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.ShipmentId')
    },
    attrs: {
      "id": "ShipmentId",
      "type": "text",
      "name": "ShipmentId",
      "placeholder": "Enter Shipping ID"
    },
    domProps: {
      "value": (_vm.ShipmentId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShipmentId = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ShipmentId')),
      expression: "errors.has('form-1.ShipmentId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s("Please Enter Shipping ID"))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Shipment Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.shipmenttype,
      "selected-option": _vm.shipmentObj,
      "name": "shipment",
      "placeholder": "Select Shipment Type"
    },
    on: {
      "select": _vm.SelectShipmentType
    },
    model: {
      value: (_vm.shipment),
      callback: function($$v) {
        _vm.shipment = $$v
      },
      expression: "shipment"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.shipment')),
      expression: "errors.has('form-1.shipment')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s("Please Select Shipment Type"))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("User Process")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.userprocess,
      "selected-option": _vm.userprocessobj,
      "name": "process",
      "placeholder": "Select User Process"
    },
    on: {
      "select": _vm.SelectUserProcess
    },
    model: {
      value: (_vm.processvalue),
      callback: function($$v) {
        _vm.processvalue = $$v
      },
      expression: "processvalue"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.process')),
      expression: "errors.has('form-1.process')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s("Please Select User Process"))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading,
      "text": "Please wait"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading == true
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" Update")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading == true
    },
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])], 1)], 1)])])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-231355c7","hasScoped":true}!./src/views/components/ShipmentUpdate/ShipmentUpdate.component.html
// module id = 1425
// module chunks = 1